import React from 'react';
import ResponsableInventario from 'components/Tvendo/Inventory/Operations/ResponsableInventario/List';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <ResponsableInventario
      title="responsables de la toma de inventario"
      excelName="responsableInventario"
      entity="logi/inventory-manager"
      permissions={{
        store: ConstantPermissions.LOGI_INVENTORIES_STORE,
        show: ConstantPermissions.LOGI_INVENTORIES_SHOW,
        delete: ConstantPermissions.LOGI_INVENTORIES_DELETED
      }}
    />
  );
}
